import React, { useMemo } from 'react';
import { Link } from '@this/shared/ui/navigations/link';

interface Props {
  tripId: number;
  serviceTel: string;
  isPremiumSupport: boolean;
  mode: 'bulk' | 'individual';
}

const CancelPolicyContent: React.FC<Props> = ({ tripId, serviceTel, isPremiumSupport, mode }) => {
  const styles = useMemo(() => getStyles(), []);

  const intraScopeNotice =
    mode === 'bulk'
      ? '旅程の一部をキャンセルしたい場合、旅程詳細画面より個別キャンセル依頼をご利用ください。'
      : '旅程全体をキャンセルしたい場合、旅程詳細画面より一括キャンセル依頼をご利用ください。';

  const businessHours = isPremiumSupport ? '9:00〜18:00' : '9:00〜18:00（平日）';

  return (
    <div>
      <p style={styles.sectionTitle}>【キャンセル依頼について】</p>
      <ul style={styles.list}>
        <li>
          この画面で行うキャンセル依頼は、株式会社トランスファーデータに対する「要望」として行われるものであり、ご利用の宿泊施設・交通機関等（以下、「サプライヤー」といいます。）へのキャンセル依頼ではありませんので、あらかじめご了承ください。
        </li>
        <li>
          また、サプライヤーのキャンセルポリシーによっては、必ずしもご返金をお約束できるものではございませんので、重ねてご了承ください。
        </li>
        <li>なお、{intraScopeNotice}</li>
      </ul>

      <p style={styles.sectionTitle}>【ご利用当日のキャンセル依頼】</p>
      <ul style={styles.list}>
        <li>
          当日のキャンセルは、ご自身でご対応をお願いいたします（キャンセル方法は
          <Link isExternal href="https://aitravel.jp/knowledges/000001075">
            こちら
          </Link>
          をご確認ください）。
        </li>
        <li>
          ご自身でキャンセルした場合は、弊社にてご請求データを更新する必要がございます。キャンセルがお済みになりましたら、その旨チャットよりお知らせください。
        </li>
      </ul>

      <p style={styles.sectionTitle}>【キャンセル料金について】</p>
      <ul style={styles.list}>
        <li>
          お客様の本画面キャンセル依頼を受け、当社は、サプライヤーのキャンセルポリシーに則ってキャンセル依頼を行います。
        </li>
        <li>
          サプライヤーやキャンセルポリシーによっては、サプライヤーの違約金・キャンセル料金が発生する場合がございます。
        </li>
      </ul>

      <p style={styles.sectionTitle}>【注意事項】</p>
      <ul style={styles.list}>
        <li>キャンセルご依頼後の、キャンセル依頼の取り消しはできかねます。</li>
        <li>弊社の手配手数料等事務手数料は、返金対象外でございます。</li>
      </ul>

      <p style={styles.contactIntro}>質問、不明点がある場合は下記までお問い合わせください。</p>
      <div style={styles.contactRow}>
        <span style={styles.contactLabel}>チャット</span>
        <Link isExternal href={`/trips/${tripId}/messages`}>
          チャットを開く
        </Link>
      </div>
      <div style={styles.contactLabel}>電話窓口</div>
      <div>TEL：{serviceTel}</div>
      <div style={styles.contactLabel}>＜営業時間＞</div>
      <div>{businessHours}</div>
    </div>
  );
};

const getStyles = () => ({
  sectionTitle: {
    fontWeight: 'bold' as const,
    marginBottom: 10
  },
  list: {
    listStyle: 'disc' as const,
    paddingLeft: 20,
    marginBottom: 20
  },
  contactIntro: {
    marginBottom: 20
  },
  contactRow: {
    display: 'flex' as const,
    justifyContent: 'space-between' as const,
    fontWeight: 'bold' as const,
    margin: '8px 0'
  },
  contactLabel: {
    fontWeight: 'bold' as const,
    margin: '8px 0'
  }
});

export default CancelPolicyContent;
